<template>
  <div class="pg-button-group-table">
    <div v-for="(item, index) in shortcutButtons" :key="item.code" style="display: inline-block">
      <ButtonItem
        class="pg-button-group-table__row-btn"
        :class="{ 'pg-button-group__row-danger': item.style === 'error' }"
        size="small"
        type="text"
        :action="action"
        :menu="item"
        :compileData="compileData"
        :title="onlyIcon ? item.name : undefined"
        >{{ onlyIcon ? '' : item.name }}<PgTextTip :text="item.title"
      /></ButtonItem>
      <Divider direction="vertical" v-if="index !== shortcutButtons.length - 1"></Divider>
    </div>

    <Dropdown
      class="pg-button-group-table__dropdown"
      trigger="hover"
      v-show="otherButtons.length > 0"
    >
      <i class="ivu-icon-icon-pg-operation icon" v-if="shortcutButtons.length === 0"></i>
      <ElButton v-else size="small" type="text" class="pg-button-group-table__row-btn"
        >更多<i class="ivu-icon-icon-pg-xiangxia pg-button-group-table__dropdown-other-icon"></i
      ></ElButton>
      <!-- <span v-else>更多</span> -->
      <template v-slot:dropdown>
        <DropdownMenu class="pg-button-group__dropdown-menu">
          <DropdownItemButton
            class="pg-button-group__dropdown-down-item"
            v-for="item in otherButtons"
            :class="{ 'pg-button-group__row-danger': item.style === 'error' }"
            :action="action"
            :key="item.code"
            size="small"
            type="text"
            :menu="item"
            :compileData="compileData"
            >{{ item.name }}<PgTextTip :text="item.title"
          /></DropdownItemButton>
        </DropdownMenu>
      </template>
    </Dropdown>
  </div>
</template>
<script setup>
import { toRef, inject, computed } from 'vue'
import { Dropdown, DropdownMenu, Divider } from 'element-ui'
import DropdownItemButton from './dropdown-item.vue'
import ButtonItem from './button-item.vue'
import { BUTTONACTION } from '../../../tokens/index'
import { useShowGroupTable } from '../hook/use-show'
import { PgTextTip } from '../../text-tip/index'

const props = defineProps({
  list: Array,
  compileData: Object,
  customAction: Function,
  shortcutNum: Number,
  onlyIcon: Boolean,
})

const { buttonList } = useShowGroupTable(toRef(props, 'compileData'), toRef(props, 'list'))
const shortcutButtons = computed(() => buttonList.value.slice?.(0, props.shortcutNum ?? 0) ?? [])
const otherButtons = computed(() => buttonList.value.slice?.(props.shortcutNum ?? 0) ?? [])

const action = props.customAction ?? inject(BUTTONACTION, null)
</script>
<style lang="scss">
@import '../style/button-group.scss';
</style>
